export enum AcEnumDDTableProperty {
  defaultOrderBy = "default_order_by",
  index = "index",
  pluralName = "plural_name",
  selectQueryFields = "select_query_fields",
  selectQuery = "select_query",
  selectRequestFields = "select_request_fields",
  selectViewName = "select_view_name",
  singularName = "singular_name",
  additionalFilterFields = "additional_filter_fields",
}
